/* eslint-disable no-unused-vars */
import { NizzaProductRequestOriginTypes } from '@nizza/core';
import { useContext, useEffect, useState } from 'react';
import { ActionsContext, SettingContext } from '../context';
import { resolveProduct } from '../services';
import { PlayerProduct } from '../types';

type useFetchProductById = {
  productId: string | undefined;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const useFetchProductById = ({ productId }: useFetchProductById) => {
  const {
    setting: { account, getProductId, originOfProducts },
  } = useContext(ActionsContext);

  const { infoSocket } = useContext(SettingContext);
  const { showTax } = infoSocket || {};
  const [product, setProduct] = useState<PlayerProduct>();
  const [loading, setLoading] = useState<boolean>(false);

  const customResolveProduct = async () => {
    if (!getProductId) {
      throw new Error(
        '[useFetchProductById] customer custom function to get the product is not defined',
      );
    }

    if (!productId) {
      throw new Error('[useFetchProductById] productId is not defined');
    }

    return getProductId(productId, account, showTax);
  };

  useEffect(() => {
    setLoading(false);

    const successResponse = (respon: any) => {
      if (respon) {
        setProduct(respon);
        setLoading(true);
      }
    };

    if (productId) {
      if (getProductId) {
        customResolveProduct().then(successResponse);
      } else {
        resolveProduct({
          productId,
          origin: originOfProducts as NizzaProductRequestOriginTypes,
          accountApplyTax: showTax,
        }).then(successResponse);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productId]);

  return { product, loading };
};
